import React from "react";
import ActionsComponent from "../../ActivationCode/tableComponents/actionsComponent";

const SignatureImg = ({value}) => <img src={value} alt="sign" className="table-signature"/>

export const cliniciansTableHeader = [
    {label: "First name", sortOption: false, classname: "font-size-13 table-caption-label"},
    {label: "Last name", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {label: "Email address", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {label: "GMC", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {label: "Signature", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {
        label: "Action",
        sortOption: false,
        classname: "font-size-13 table-caption-label disable-word-wrap action-table-cell"
    },
];

export const cliniciansTableStructure = [
    {
        name: "firstName",
        classname: "font-size-14 pt-20px pb-20px border-bottom fullname-table-cell",
        keyProp: "firstName"
    },
    {name: "lastName", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "lastName"},
    {name: "email", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "email"},
    {name: "gmc", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "doctor.gmc"},
    {
        name: "signature",
        classname: "font-size-13 pt-20px pb-20px border-bottom",
        keyProp: "doctor.link",
        Component: SignatureImg
    }, //todo: img component
    // { name: "actions", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "id", Component: (({value}) => value) },
]

/**
 * superAdmin only: whether this clinician sees every doctor's patients in the default lists while
 * "own patients only" is on. For admin and ID-check staff, who work across every doctor's list.
 *
 * The API reports hasFullPatientAccess for clinicians (role 1) only. A row without it is a super
 * admin, who always sees every patient and cannot hold the grant, so it gets no checkbox.
 */
export const FullPatientAccessToggle = ({ clinician, onToggle }) => (typeof clinician.hasFullPatientAccess !== "boolean" ? (
    <span data-testid={`full-access-${clinician.id}-fixed`}>All patients</span>
) : (
    <label className="d-flex align-items-center mb-0 cursor-pointer">
        <input
            type="checkbox"
            className="mr-2"
            data-testid={`full-access-${clinician.id}`}
            checked={Boolean(clinician.hasFullPatientAccess)}
            onChange={event => onToggle(clinician, event.target.checked)}
        />
        <span>{clinician.hasFullPatientAccess ? "All patients" : "Own patients"}</span>
    </label>
));

export const fullPatientAccessHeader = {
    label: "Patient lists",
    sortOption: false,
    classname: "font-size-13 table-caption-label disable-word-wrap",
};

export const cliniciansStructureWithActions = (handleEdit, onToggleFullAccess) => {
    return [
        ...cliniciansTableStructure,
        ...(onToggleFullAccess ? [{
            name: "fullPatientAccess",
            classname: "font-size-13 pt-20px pb-20px border-bottom",
            Component: (({value}) => <FullPatientAccessToggle clinician={value} onToggle={onToggleFullAccess}/>)
        }] : []),
        {
            name: "actions",
            classname: "font-size-13 pt-20px pb-20px pr-2 pl-3 border-bottom",
            Component: (({value}) => <ActionsComponent item={value} handleEdit={handleEdit}/>)
        },
    ]
}